import React from "react";

export default function SelectInput(props) {
    const normalizedOptions = React.Children.toArray(props.options);
    const selectValue =
        props.value === undefined || props.value === null ? "" : props.value;

    const handleChange = (event) => {
        const rawValue = event.target.value;
        const nextValue =
            rawValue === ""
                ? ""
                : props.parse === false
                ? rawValue
                : parseInt(rawValue, 10);

        if (props.Idx != null) {
            props.handleChange(props.name, nextValue, props.Idx);
            return;
        }

        props.handleChange(props.name, nextValue);
    };

    return (
        <div className={props.containerStyle ? props.containerStyle : "w-full"}>
            {props.label && <label htmlFor={props.name} className={props.labelClassName ? props.labelClassName : "text-sm font-medium text-gray-700 dark:text-gray-200"}>
                {props.label}
                {props.required ? <p className="font-medium text-[#F51515] inline-block ml-2"> *</p> : null}
            </label>}
            <select
                disabled={props.disabled}
                value={selectValue}
                onChange={handleChange}
                type="text"
                name={props.name}
                id={props.name}
                className={props.className ? props.className : "shadow-sm w-full mt-1 mx-auto pr-6 border border-gray-300 block sm:text-sm rounded-md input-base"}
            >
                {props.placeholder ? (
                    <option hidden value="">
                        {" "}
                        {props.placeholderText ? props.placeholderText : "--"}{" "}
                    </option>
                ) : null}
                {normalizedOptions}
            </select>
            {props.errorMessage && <p className="mt-2 text-sm text-red-600" id={`${props.name}-error`}>
                {props.errorMessage}
            </p>}
        </div>
    )

}